import React, { useState } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import { omsService } from "../../utils/services/omsProvider";
import { tmsService } from "../../utils/services/tmsService";
import { wmsService } from "../../utils/services/wmsProvider";
import OMSList from "./oms-list";
import TMSList from "./tms-list";
import WMSList from "./wms-list";
import CostRateList from "./cost-rate-list";
import ClientProviderModal from "../client-provider-modal";

const ClientConfiguration = ({
  providerData,
  onEditOms,
  onEditWms,
  onEditTms,
  clientId,
  onClickLocation,
  setSelectedProvider,
  onViewOmsData,
  onDeleteSuccess,
  isDisabled,
  onClickAddOms,
  onClickAddWms,
  onClickAddTms,
  onViewTmsData,
  onViewWmsData,
  isOpened,
  viewOnly,
  setOpenOmsModal,
  onCloseModal,
  selectedData,
  selectedClient,
  wms,
  tms,
  openOmsModal,
  providerList,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedProviderData, setSelectedProviderData] = useState(null);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [provider, setProvider] = useState("oms");
  const [openWebhook, setOpenWebhook] = useState(null);
  const [webhooks, setWebhooks] = useState([]);
  const [selectedWebhookData, setSelectedWebhookData] = useState(null);

  const handleDeleteClick = (data, type) => {
    setProvider(type);
    setShowDeleteConfirmationModal(true);
    setSelectedProviderData(data);
  };

  const handleDeleteData = async () => {
    if (selectedProviderData) {
      try {
        setLoading(true);
        if (provider == "tms") {
          await tmsService.delete(selectedProviderData?._id);
        } else if (provider == "wms") {
          await wmsService.delete(selectedProviderData?._id);
        } else if (provider == "oms") {
          await omsService.delete(selectedProviderData?._id);
        }
      } catch (error) {
        console.error("Delete failed:", error);
      } finally {
        setLoading(false);
        setShowDeleteConfirmationModal(false);
        onDeleteSuccess && onDeleteSuccess();
        setSelectedProviderData(null);
      }
    }
  };

  const RenderList = () => {
    switch (selectedTab) {
      case 0:
        return (
          <OMSList
            isOpened={isOpened}
            disabled={isDisabled}
            onClickAddOms={onClickAddOms}
            onViewOmsData={onViewOmsData}
            onEditOms={onEditOms}
            handleDeleteClick={(data) => handleDeleteClick(data, "oms")}
            clientId={clientId}
            setLoading={setLoading}
            loading={loading}
            onClickLocation={onClickLocation}
            setSelectedProvider={setSelectedProvider}
            openWebhook={openWebhook}
            setOpenWebhook={setOpenWebhook}
            webhooks={webhooks}
            setWebhooks={setWebhooks}
            selectedWebhookData={selectedWebhookData}
            setSelectedWebhookData={setSelectedWebhookData}
          />
        );
      case 1:
        return (
          <TMSList
            isOpened={isOpened}
            onEditTms={onEditTms}
            clientId={clientId}
            disabled={isDisabled}
            onClickAddTms={onClickAddTms}
            onViewTmsData={onViewTmsData}
            handleDeleteClick={(data) => handleDeleteClick(data, "tms")}
          />
        );
      case 2:
        return (
          <WMSList
            isOpened={isOpened}
            onEditWms={onEditWms}
            clientId={clientId}
            disabled={isDisabled}
            onClickAddWms={onClickAddWms}
            handleDeleteClickWms={(data) => handleDeleteClick(data, "wms")}
            onViewWmsData={onViewWmsData}
          />
        );
      case 3:
        return (
          <CostRateList
            isOpened={isOpened}
            clientId={clientId}
            disabled={isDisabled || viewOnly}
          />
        );
      default:
        return (
          <div>
            <Typography>Not Implemented!</Typography>
          </div>
        );
    }
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={selectedTab}
        onChange={(e, newValue) => setSelectedTab(newValue)}
      >
        <Tab label="OMS" />
        <Tab label="TMS" />
        <Tab label="WMS" />
        <Tab label="Cost rates" />
      </Tabs>
      <Box sx={{ p: 2 }}>
        <RenderList />
      </Box>

      <DeleteConfirmationModal
        handleDelete={() => handleDeleteData()}
        handleClose={() => {
          setShowDeleteConfirmationModal(false);
          setSelectedProviderData(null);
        }}
        title={`Are you sure to delete this provider ${
          selectedProviderData?.provider?.name || ""
        }`}
        open={showDeleteConfirmationModal}
      ></DeleteConfirmationModal>
      <ClientProviderModal
        viewOnly={viewOnly}
        onDeleteSuccess={() => {
          setOpenOmsModal(false);
        }}
        loading={loading}
        setLoading={setLoading}
        onAddProviderData={() => onCloseModal()}
        selectedData={selectedData.map((x) => ({
          ...x,
          provider: x?.provider?._id,
        }))}
        selectedClient={selectedClient}
        wms={wms}
        tms={tms}
        onClose={() => onCloseModal()}
        setOpen={setOpenOmsModal}
        open={openOmsModal}
        providerList={providerList}
      ></ClientProviderModal>
    </Box>
  );
};

export default ClientConfiguration;
